<template>
  <div :class="cn()">
    <div :class="cn('inner')">
      <ShopifyLinks :class="cn('menu')" aria-label="Main navigation" :links="main.links" />
      <ShopifyLinks
        :class="[cn('menu'), cn('menu--account')]"
        aria-label="Account navigation"
        :links="account.links"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { LiquidLinkList } from '../../types'
import { bem } from '../../utils/classnames.ts'
import ShopifyLinks from '../shopify/link/ShopifyLinks.vue'

defineProps<{
  main: LiquidLinkList
  account: LiquidLinkList
}>()

const cn = bem('header-overlay')
</script>

<style lang="scss">
@import '~styles/base.scss';

a.shopify-link.shopify-link--inactive.shopify-link.shopify-link--default.shopify-link--depth-0.shopify-link--index-0 {
  margin-bottom: 0 !important;
}

.header-overlay
  .shopify-link-dropdown__links
  .shopify-link--submenu:not(.shopify-link--submenu ~ .shopify-link--submenu) {
  margin-top: 0;
}

.shopify-link.shopify-link--space.shopify-link--depth-0.shopify-link--index-8 {
  height: 6px;
}

.shopify-link-dropdown__links {
  .shopify-link:not(.shopify-link--submenu) {
    padding-left: 12px;
  }
}

.header-overlay {
  > .shopify-link-dropdown--active {
    .shopify-link-dropdown__title {
      text-decoration: underline;
    }
  }
}

.header-overlay {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: var(--color-background);
  z-index: 1000;
  padding-top: 128px;
  pointer-events: auto;
  overflow: hidden;

  &__inner {
    @include wrapper;
    height: 100%;
  }

  &__menu {
    position: relative;

    & + & {
      padding-top: 128px;
    }

    &--account {
      @include type-xs-uppercase;
    }
  }

  .shopify-links {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .shopify-link--search {
    @include type-xs;
  }

  .shopify-link-dropdown {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--gutter);

    &__title {
      @include type-xs-uppercase;
    }

    &__links {
      position: absolute;
      top: -128px;
      right: 0;
      width: calc(50% - var(--gutter) / 2);
      height: 100dvh !important;
      max-height: 100dvh !important;
      overflow-y: auto !important;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
      padding-top: 128px;
      padding-left: 0;
      padding-bottom: 32px;
      background: var(--color-background);
      box-sizing: border-box;
      z-index: 10;

      .shopify-link {
        &--submenu {
          text-decoration: none !important;
          margin-top: 24px;
          margin-bottom: 0px;
          pointer-events: none !important;
          cursor: default !important;
        }

        &--default + &--submenu {
          margin-top: 16px;
        }

        &--heading {
          @include type-xxs-uppercase;
          color: var(--color-dark);
          margin-top: 16px;
          margin-bottom: 0px;

          @include hover {
            &:after {
              display: none;
            }
          }
        }

        &--heading:not(:first-of-type) {
          margin-top: 16px;
        }

        + *:not(.shopify-link--heading):not(.shopify-link--submenu) {
          margin-top: 4px;
        }

        &:first-child:not(.shopify-link--submenu):not(.shopify-link--heading) {
          margin-top: 0;
          margin-bottom: 8px;
        }

        &:last-child {
          margin-bottom: 16px;
        }
      }
    }
  }

  .shopify-link--currencies {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--gutter);
  }
}
</style>
